import axios from 'axios';

export default axios.create({
  baseURL: 'https://api.upa.trixlog.com/auth'
  // baseURL: 'http://localhost:8080/auth'
});




// WEBPACK FOOTER //
// ./src/config/config-auth.js